import { createReducer, on } from '@ngrx/store';
import { FeatureScopeActions } from './feature-scope.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import {FeatureScope} from '@emm/core/util/feature-scope.constants';

export const featureScopeFeatureKey = 'featureScope';

export interface FeatureScopeState {
    selectedScope: string;
}

export const initialState: FeatureScopeState = {
    selectedScope: FeatureScope.Viewer,
};

export const featureScopeReducer = createReducer(
    initialState,
    on(FeatureScopeActions.select, (state, { scope }) => ({
        ...state,
        selectedScope: scope
    })),

    on(MenuBaseActions.init, () => ({
        ...initialState,
    }))

);
